import Icon from '../components/Icon.vue'

Icon.register({
  'circle-notch': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M288 39.1V55.7C288 66.5 295.3 75.9 305.7 78.8 383.2 100.4 440 171.5 440 256 440 357.7 357.7 440 256 440 154.3 440 72 357.7 72 256 72 171.5 128.8 100.4 206.3 78.8 216.7 75.9 224 66.5 224 55.7V39.1C224 23.4 209.2 11.9 194 15.8 86.6 43.5 7.4 141.2 8 257.3 8.7 394.4 119.5 504.3 256.5 504 393.3 503.7 504 392.8 504 256 504 140.4 424.9 43.2 317.8 15.8 302.7 11.9 288 23.5 288 39.1z'
      }
    ]
  }
})
